// import { loginByCode } from '@/card/api/login'
import axios from 'axios'
import {
  loadAppid,
  loadHomeUrl,
  loadCerUrl,
  loadCn,
  loadIccid,
  loadLoginStatus,
  loadOpenid,
  loadPrepare,
  loadToken,
  loadTemplate,
  loadType,
  removeAppid,
  removeHomeUrl,
  removeCerUrl,
  removeCn,
  removeIccid,
  removeLoginStatus,
  removeOpenid,
  removePrepare,
  removeToken,
  removeType,
  removeTemplate,
  saveAppid,
  saveHomeUrl,
  saveCerUrl,
  saveCn,
  saveIccid,
  saveLoginStatus,
  saveOpenid,
  savePrepare,
  saveToken,
  saveTemplate,
  saveType
} from '@/utils/cache'

const state = {
  loginStatus: loadLoginStatus(), // 登录状态
  Cn: loadCn(), // 卡标识
  Type: loadType(),
  Prepare: loadPrepare(),
  Token: loadToken(),
  Template: loadTemplate(),
  Iccid: loadIccid(),
  CerUrl: loadCerUrl(),
  Openid: loadOpenid(),
  Appid: loadAppid(),
  HomeUrl: loadHomeUrl()
}

const mutations = {
  // SET_USERINFO: (state, userInfo) => {
  //   state.userInfo = userInfo
  // },
  SET_LOGIN_STATUS: (state, loginStatus) => {
    state.loginStatus = loginStatus
  },
  SET_CN: (state, Cn) => {
    state.Cn = Cn
  },
  SET_HOME_URL: (state, homeUrl) => {
    state.HomeUrl = homeUrl
  },
  SET_TYPE: (state, Type) => {
    state.Type = Type
  },
  SET_PREPARE: (state, Prepare) => {
    state.Prepare = Prepare
  },
  SET_TOKEN: (state, Token) => {
    state.Token = Token
  },
  SET_ICCID: (state, Iccid) => {
    state.Iccid = Iccid
  },
  SET_CER_URL: (state, CerUrl) => {
    state.CerUrl = CerUrl
  },
  SET_OPENID: (state, Openid) => {
    state.Openid = Openid
  },
  SET_APPID: (state, Appid) => {
    state.Appid = Appid
  },
  SET_TEMPLATE: (state, Template) => {
    state.Template = Template
  }
}

const actions = {
  // 登录相关，通过code获取token和用户信息
  loginWechatAuth ({ commit }, {code, appid}) {
    // const data = {
    //   code: code
    // }
    return new Promise((resolve, reject) => {
      axios.get('/wechat/card/wxAuth2?code=' + code + '&appid=' + appid)
        .then(res => {
          // 存用户信息，token
          // commit('SET_USERINFO', saveUserInfo(res.data.user))
          // commit('SET_TOKEN', saveToken(res.data.token))
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 设置状态
  setLoginStatus ({ commit }, query) {
    if (query === 0 || query === 1) {
      // 上线打开注释，本地调试注释掉，保持信息最新
      // removeToken()
      // removeUserInfo()
    }
    // 设置不同的登录状态
    commit('SET_LOGIN_STATUS', saveLoginStatus(query))
  },
  // 设置状态
  setCn ({ commit }, query) {
    commit('SET_CN', saveCn(query))
  },
  setHomeUrl ({ commit }, query) {
    commit('SET_HOME_URL', saveHomeUrl(query))
  },
  // 设置类型
  setType ({ commit }, query) {
    commit('SET_TYPE', saveType(query))
  },
  setPrepare ({ commit }, query) {
    commit('SET_PREPARE', savePrepare(query))
  },
  // 设置token
  setToken ({ commit }, query) {
    commit('SET_TOKEN', saveToken(query))
  },
  // 设置Iccid
  setIccid ({ commit }, query) {
    commit('SET_ICCID', saveIccid(query))
  },
  // 设置Iccid
  setCerUrl ({ commit }, query) {
    commit('SET_CER_URL', saveCerUrl(query))
  },
  // 设置openid
  setOpenid ({ commit }, query) {
    commit('SET_OPENID', saveOpenid(query))
  },
  // 设置appid
  setAppid ({ commit }, query) {
    commit('SET_APPID', saveAppid(query))
  },
  setTemplate ({ commit }, query) {
    commit('SET_TEMPLATE', saveTemplate(query))
  },
  // 登出
  fedLogOut () {
    removeCn()
    removeHomeUrl()
    removeToken()
    removeType()
    removePrepare()
    removeIccid()
    removeCerUrl()
    removeLoginStatus()
    removeOpenid()
    removeAppid()
    removeTemplate()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js